import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_main/quero-ser-fornecedor')({
  loader: () => {
    throw redirect({
      to: '/quero-anunciar',
      replace: true,
    });
  },
});
